import * as reportError from 'airship/modules/error-reporting'
import * as getUrl from 'airship/modules/get-url'
import * as createRequest from 'airship/modules/request2/ua-request'
import * as cache from '../session-cache'
import {EventBackendProps, UserBackendProps} from './types'

const APP_KEY: string | null =
  getUrl.APP_KEY && getUrl.APP_KEY.length === 22 ? getUrl.APP_KEY : null
const CACHE_EXPIRY = 6 * cache.Duration.Hour
// getUrl does not work on these pages, probably because iframes:
const DISABLE_ON_URL_FRAGMENTS = [
  '/composer/rich_composer/',
  '/composer/-/richpush/'
]

interface BackendProps {
  user?: UserBackendProps
  event?: EventBackendProps
}

export async function getEventProperties(): Promise<BackendProps | null> {
  if (shouldIgnorePage()) {
    return null
  }
  if (APP_KEY) {
    return getAppEventProperties()
  }

  // Coming soon: handle more types of pages. See WEB-780.

  return null
}

async function getAppEventProperties(): Promise<BackendProps | null> {
  let props: BackendProps | null | undefined = null

  const cacheKey = `props-${APP_KEY}`
  props = cache.get<BackendProps>(cacheKey)
  if (!props) {
    try {
      props = await fetchAppEventProperties()
      cache.set(cacheKey, props, CACHE_EXPIRY)
    } catch (err) {
      reportError(err, __filename)
    }
  }

  return props || null
}

async function fetchAppEventProperties(): Promise<BackendProps | null> {
  const path = getUrl(
    'analytics:analytics_api_app_event_properties',
    getUrl.APP_KEY
  )
  const query = {path: window.location.pathname}
  const req = createRequest({path})
  const res = await req.get({query})
  req.end()

  if (res.statusCode !== 200) {
    throw new Error(`Event properties API returned ${res.statusCode}`)
  }

  return res.body
}

function shouldIgnorePage(): boolean {
  const pathname: string = window.location && window.location.pathname
  if (!pathname) {
    return true
  }
  for (const fragment of DISABLE_ON_URL_FRAGMENTS) {
    if (pathname.includes(fragment)) {
      return true
    }
  }

  return false
}
